import BaseModelAPI from '../BaseModelAPI';

export default class StockAdjustmentList extends BaseModelAPI {

	static entity = 'stockadjustmentlist'
	static entityName = 'stockadjustment';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
